import React from "react";
import styles from "./Language.module.css";
import classNames from "classnames";

export const Language = ({ changeLanguage }) => {
  const [language, setLanguage] = React.useState(localStorage.getItem("i18nextLng")=='ru'?"ru":"kz");
  const kazStyle = classNames(
    styles.language,
    language == "kz" ? styles.active : null
  );
  const rusStyle = classNames(
    styles.language,
    language == "ru" ? styles.active : null
  );
  const handleLanguage = (lang) => {
    changeLanguage(lang);
    setLanguage(lang);
  };
  return (
    <div className={styles.languages}>
      <span onClick={() => handleLanguage("kz")} className={kazStyle}>
        Каз
      </span>
      <span onClick={() => handleLanguage("ru")} className={rusStyle}>
        Рус
      </span>
    </div>
  );
};
